import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';
import {BaseService} from "app/views/base.service";
import { DataProviderFactory, DataRequest } from "../provider/data2.provider";


@Injectable()
export class TemplateService extends BaseService {
	public tag: DataRequest;
	public siteSubCategories: DataRequest;
	public template: DataRequest;

	constructor(
		public http: HttpClient,
		public dpf: DataProviderFactory,
	) {
		super(http);

		this.tag = this.dpf.getNew('template_tag');
		this.siteSubCategories = this.dpf.getNew('site_sub_categories');
		this.template = this.dpf.getNew('template');
	}
}
